import { useFela } from 'react-fela';
import * as PropTypes from 'prop-types';
import Divider from 'antd/lib/divider';
import { Link } from 'react-router-dom';

import config from 'config/index';

import DeletePin from '../../containers/DeletePin';

import rule from './Pin.rule';

const pinPropTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

export const pinShape = PropTypes.shape(pinPropTypes);

const Pin = ({ id, title }) => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <h4>
                <Link to={config.routes.pinsDetail.replace(':id', id)}>{title}</Link>
                <DeletePin size="small" id={id} />
            </h4>
            <Divider />
        </div>
    );
};

Pin.propTypes = pinPropTypes;

export default Pin;
